// Contextual rows stay separate from the document and never contain display URLs.
export function cloneMediaUsages(rows, originals, copies) {
  originals.forEach((block, index) => {
    if (block.type !== "image") return
    const usage = rows.find(row => row.placement_key === block.id)
    if (usage) rows.push({ ...usage, placement_key: copies[index].id })
  })
}
export function removeMediaUsage(rows, key) {
  const index = rows.findIndex(row => row.placement_key === key)
  if (index >= 0) rows.splice(index, 1)
}
export function selectMediaAsset(rows, key, asset) {
  let usage = rows.find(row => row.placement_key === key)
  if (usage) usage.media_asset_id = asset.id
  else {
    usage = { placement_key: key, media_asset_id: asset.id, alt_text: asset.alt_text, caption: asset.caption, decorative: false }
    rows.push(usage)
  }
  return usage
}
export function copyMediaDefaults(usage, asset) {
  usage.alt_text = usage.decorative ? "" : asset.alt_text
  usage.caption = asset.caption
}
